import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'account',
    templateUrl: 'account.component.html',
    styleUrls: ['account.component.css'],
})
export class AccountComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';

    constructor() {
    }

    ngOnInit() {

    }

    login() {

    }
}
